import { EntityApi } from "../../services/ApiPlatform";

export abstract class StudentSkillCommentApi extends EntityApi {
    protected static GET_COLLECTION = "/api/student-skill-comments";

    protected static POST_COLLECTION = "/api/student-skill-comments";

    protected static GET_ITEM = "/api/student-skill-comments/{id}";

    protected static PUT_ITEM = "/api/student-skill-comments/{id}";

    protected static PATCH_ITEM = "/api/student-skill-comments/{id}";

    protected static DELETE_ITEM = "/api/student-skill-comments/{id}";
}
